module.exports = __webpack_public_path__ + "img/icon-物理@2x.c111628d.png";